import { AppBox, AppLink, AppPaper, AppScorePill, AppText } from "../../../../../commons/components";
import { IFootballMatch } from "../../../../../commons/models/football/interface/i-football-match";
import AppRoundedDivider from "../../../../../commons/components/RoundedDivider";
import IconAdd from "../../../../../commons/components/icons/add";
import ability from "../../../../../casl/Can";
import { RolePolicyActionEnum } from "../../../../../commons/enums/role-policy-action.enum";
import { FootballMatchDetail } from "../../../../../commons/models/football/football-match-detail";
import { useAppSelector } from "../../../../../hooks/app";
import { ManageFootballTeam } from "../../../../../commons/models/football/admin/manage-football-team";
import { IFootballHostedCompetition } from "../../../../../commons/models/football/interface/i-football-competition";

interface EmptyFixtureCardProps {
  fixture: IFootballMatch;
  onEdit: (match: IFootballMatch) => void;
}

export const EmptyFixtureCard = ({ fixture, onEdit }: EmptyFixtureCardProps) => {
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);
  const canCreateMatch =
    ability.can(RolePolicyActionEnum.CREATE, new FootballMatchDetail().create(fixture) as FootballMatchDetail) ||
    ability.can(
      RolePolicyActionEnum.UPDATE,
      new ManageFootballTeam((fetchedCompetition as IFootballHostedCompetition).hostTeam)
    );
  const handleItemClick = () => {
    if (canCreateMatch) {
      onEdit(fixture);
    }
  };
  return (
    <AppLink style={{ pointerEvents: canCreateMatch ? "auto" : "none" }} onClick={handleItemClick} className="w-100">
      <AppPaper padding="xs" withBorder className="w-100">
        <AppBox flexDirection="column" gap="2xs">
          <AppBox alignItems="center" justifyContent="center">
            <AppText textAlign="center">Schedule match</AppText>
            {fixture.title && (
              <>
                <AppRoundedDivider mx="2xs" />
                <AppText textAlign="center">{fixture.title}</AppText>
              </>
            )}
          </AppBox>
          <AppBox gap="xs" justifyContent="space-between" alignItems="center">
            <AppBox justifyContent="center" alignItems="center" flexDirection="column" gap="xs" className="flex-1">
              <AppBox className="team-add-svg" alignItems="center" justifyContent="center">
                <IconAdd />
              </AppBox>
              <AppBox flexDirection="column" alignItems="center" justifyContent="center">
                <AppText>Select a team</AppText>
              </AppBox>
            </AppBox>
            <AppBox flexDirection="column" alignItems="center" gap="2xs">
              <AppScorePill matchStatus={"upcoming"} />
            </AppBox>
            <AppBox justifyContent="center" alignItems="center" flexDirection="column" gap="xs" className="flex-1">
              <AppBox className="team-add-svg" alignItems="center" justifyContent="center">
                <IconAdd />
              </AppBox>
              <AppBox flexDirection="column" alignItems="center" justifyContent="center">
                <AppText>Select a team</AppText>
              </AppBox>
            </AppBox>
          </AppBox>
        </AppBox>
      </AppPaper>
    </AppLink>
  );
};
